import { useState } from "react";
import ButtonLink from "./ButtonLink";

export default function Fetch() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  function submit(e) {
    // This will prevent page refresh
    e.preventDefault();

    // replace this with your own unique endpoint URL
    fetch("https://formcarry.com/s/VXnqwr7ByUS", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ name: name, email: email, message: message })
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.code === 200) {
          setSubmitted(true);
        } else {
          setError(res.message);
        }
      })
      .catch((error) => setError(error));
  }

  if (error) {
    return <p>{error}</p>;
  }

  if (submitted) {
    return <p>I've received your message, thank you for contacting me!</p>;
  }

  return (
    <form onSubmit={submit}>
 <label htmlFor="name">Hello, my name is </label>
                <input id="name" name="name" placeholder="Your full name"  value={name}
        onChange={(e) => setName(e.target.value)}/> <label htmlFor="name">, and I'd like to discuss a potential
                project.</label>
<br/><br/>

      <label htmlFor="email">I can be contacted at</label>
      <input
        id="email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        placeholder="Your email"
      />
<br/><br/>

      <label htmlFor="message">Message</label><br/>

      <textarea
        id="message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <br/> <br/>
      <div className="btn__wrap">
       
<ButtonLink type="submit">Submit</ButtonLink></div>
    </form>
  );
}